import React from "react";
import PrematchOfferMenuStore from "@state/stores/offer/prematch/PrematchOfferMenuStore";
import { MainSportsList } from "@features/offer/desktop/offer-menu/components";

import { MainMenuSelectorPeriod, MainMenuFavoritesItem } from ".";

export function MainMenu(props: { store: PrematchOfferMenuStore }) {
	return (
		<nav className="nav--secondary nav--sports">
			<ul className="nav--secondary__menu nav--sports__menu">
				<MainMenuSelectorPeriod store={props.store} />
				<MainMenuFavoritesItem store={props.store} />
				<MainSportsList store={props.store} />
			</ul>
		</nav>
	);
}
